import { useSeoMeta } from '@unhead/react';
import { Link } from 'react-router-dom';
import { LoginArea } from '@/components/auth/LoginArea';

const Index = () => {
  useSeoMeta({
    title: 'No Stranger Game',
    description: 'An RPG that lives inside your social network. Play with real people as NPCs.',
  });

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="w-full max-w-md p-6 space-y-6">
        <div className="text-center">
          <h1 className="text-4xl font-bold text-gray-900 dark:text-gray-100 mb-6">
            No Stranger Game
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-400 mb-4">
            An RPG that lives inside your social network
          </p>
        </div>
        <div className="border-2 border-dashed border-gray-300 dark:border-gray-600 p-4">
          <h2 className="text-2xl font-bold mb-4 text-center">
            Connect Your Nostr Account
          </h2>
          <LoginArea className="w-full mb-4" />
          <p className="text-sm text-gray-500 dark:text-gray-400 text-center">
            Once connected, you'll be able to play the game
          </p>
        </div>
        <div className="text-sm text-gray-500 dark:text-gray-400 mt-6">
          <p>Vibed with <a href="https://shakespeare.diy" className="text-primary hover:underline">Shakespeare</a></p>
        </div>
      </div>
    </div>
  );
};

export default Index;
